
import React from 'react';
import { CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorStateProps {
  errorMessage: string;
  onRetry: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ errorMessage, onRetry }) => {
  return (
    <CardContent className="flex flex-col items-center justify-center flex-1 p-6">
      <AlertCircle className="h-12 w-12 text-red-500 mb-4" />
      <h3 className="text-xl font-semibold text-center mb-2">Connection Error</h3>
      <p className="text-center text-gray-500 mb-6">
        {errorMessage}
      </p>
      <Button 
        onClick={onRetry} 
        className="flex items-center gap-2"
      >
        <RefreshCw className="h-4 w-4" />
        Try Again
      </Button>
    </CardContent>
  );
};

export default ErrorState;
